import { Component } from '@angular/core';

@Component({
  selector: 'app-holiday-notice-modal',
  templateUrl: './holiday-notice-modal.component.html',
  styleUrls: ['./holiday-notice-modal.component.scss']
})
export class HolidayNoticeModalComponent {

}
